import { render, staticRenderFns } from "./AppConfigCustomerInformation.vue?vue&type=template&id=524954e1&"
import script from "./AppConfigCustomerInformation.vue?vue&type=script&lang=js&"
export * from "./AppConfigCustomerInformation.vue?vue&type=script&lang=js&"
import style0 from "./AppConfigCustomerInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('524954e1')) {
      api.createRecord('524954e1', component.options)
    } else {
      api.reload('524954e1', component.options)
    }
    module.hot.accept("./AppConfigCustomerInformation.vue?vue&type=template&id=524954e1&", function () {
      api.rerender('524954e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/AppConfigCustomerInformation.vue"
export default component.exports